import {
	Flex,
	MenuItem,
	Spinner,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { ItemContent } from 'components/menu/ItemContent';
import { memo, useMemo } from 'react';

const NotificationList = memo(function NotificationList({
	loading,
	notifications,
	onSetAsViewed,
	btcColor,
	hoverTextColor,
}) {
	const textColorBrand = useColorModeValue('brand.700', 'brand.400');

	const renderedItems = useMemo(() => {
		if (loading) {
			return (
				<Flex alignItems='center' justifyContent='center' h='40vh'>
					<Spinner color={textColorBrand} />
				</Flex>
			);
		}

		if (!notifications?.length) {
			return (
				<MenuItem
					_hover={{ bg: 'none' }}
					_focus={{ bg: 'none' }}
					px='0'
					borderRadius='8px'
					mb='10px'
				>
					<Flex w='100%' alignItems='center' justifyContent='center' h='40vh'>
						<Text textAlign='center'>
							No tienes notificaciones por el momento.
						</Text>
					</Flex>
				</MenuItem>
			);
		}

		return notifications.map((notification) => (
			<MenuItem
				key={notification.id}
				bg='inherit'
				_hover={
					!notification.viewed && {
						bg: btcColor,
						color: hoverTextColor,
					}
				}
				_focus={
					!notification.viewed && {
						bg: btcColor,
						color: hoverTextColor,
					}
				}
				p='10px'
				borderRadius='8px'
				mb='10px'
				cursor='default'
			>
				<ItemContent
					notification={notification}
					handleSetAsViewed={() => onSetAsViewed(notification.id)}
				/>
			</MenuItem>
		));
	}, [loading, notifications, onSetAsViewed]);

	return <Flex flexDirection='column'>{renderedItems}</Flex>;
});

export default NotificationList;
